import { ReactElement } from 'react';
import { AnnouncementSubCardPropTypes } from '../../types/propTypes/AnnouncementSubCardPropTypes';

const AnnouncementSubPanel = ({
  panelText,
  panelUrl,
  panelUrlText
}: AnnouncementSubCardPropTypes): ReactElement => (
  <>
    <p data-testid="help-center-directions-1">
      {panelText}
    </p>

    {
        panelUrl && (
          <div data-testid="help-center-directions-1">
            <ul>
              <li>
                <a href={panelUrl}>{panelUrlText}</a>
              </li>
            </ul>
          </div>
        )
    }
  </>
);

export default AnnouncementSubPanel;
